export function IconWarning() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M5.003.616a1.114 1.114 0 0 1 1.994 0l4.884 9.77A1.115 1.115 0 0 1 10.884 12H1.116a1.115 1.115 0 0 1-.997-1.613L5.003.617z" fill="#FFC738"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.528 3.5a.5.5 0 0 0-.499.528l.195 3.5A.5.5 0 0 0 5.723 8h.554a.5.5 0 0 0 .499-.472l.194-3.5a.5.5 0 0 0-.499-.528h-.943zm-.296 6.439c0 .185.046.36.173.486.127.127.301.173.486.173h.28c.18 0 .35-.047.472-.176.12-.127.164-.3.164-.483v-.291c0-.18-.044-.35-.166-.476C6.52 9.046 6.35 9 6.171 9h-.28c-.183 0-.357.045-.484.169-.128.124-.175.296-.175.479v.29z" fill="#262B2E"/>
        </svg>
    );
}
